export var isWeb = typeof window !== 'undefined' && 'onload' in window;
export var isNode = typeof process !== 'undefined' && !!(process.versions && process.versions.node);
export var isWeex = typeof WXEnvironment !== 'undefined' && WXEnvironment.platform !== 'Web';
export var isKraken = typeof __kraken__ !== 'undefined';
export var isMiniApp = typeof my !== 'undefined' && my !== null && typeof my.alert !== 'undefined';
export var isByteDanceMicroApp = typeof tt !== 'undefined' && tt !== null && typeof tt.showToast !== 'undefined';
export var isBaiduSmartProgram = typeof swan !== 'undefined' && swan !== null && typeof swan.showToast !== 'undefined';
export var isKuaiShouMiniProgram = typeof ks !== 'undefined' && ks !== null && typeof ks.showToast !== 'undefined';
// In wechat mini program, wx.login is a function
// In wechat mini propgram webview, there is no wx.login, but exist wx.miniProgram
// In bytedance maicro app, there is wx variable.
// In kuaishou mini program, there is wx variable.
export var isWeChatMiniProgram = !isByteDanceMicroApp && typeof wx !== 'undefined' && wx !== null && (typeof wx.request !== 'undefined' || typeof wx.miniProgram !== 'undefined');
export var isQuickApp = typeof global !== 'undefined' && global !== null && typeof global.callNative !== 'undefined' && !isWeex;
export var isPHA = isWeb && typeof pha === 'object';
export var isFRM = isMiniApp && isWeb && my.isFRM;

// WindVane.call is a function while page importing windvane.js
var ua = typeof navigator === 'object' ? navigator.userAgent || navigator.swuserAgent : '';
export var isWindVane = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\).* .*(WindVane)(?:\/((?:\d+\.)+\d+))?.*/.test(ua) && isWeb && typeof WindVane !== 'undefined' && typeof WindVane.call !== 'undefined';
export default {
  isWeb: isWeb,
  isNode: isNode,
  isWeex: isWeex,
  isKraken: isKraken,
  isMiniApp: isMiniApp,
  isByteDanceMicroApp: isByteDanceMicroApp,
  isBaiduSmartProgram: isBaiduSmartProgram,
  isKuaiShouMiniProgram: isKuaiShouMiniProgram,
  isWeChatMiniProgram: isWeChatMiniProgram,
  isQuickApp: isQuickApp,
  isPHA: isPHA,
  isWindVane: isWindVane,
  isFRM: isFRM
};